import { IObservableInitialState } from '../../models/ICommon';

const observableInitialStateValue: IObservableInitialState = {
  success: false,
  error: '',
  inProgress: false,
};

export default observableInitialStateValue;
